import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AuthService} from '../../../shared/services/auth/auth.service';
import {ThemeSettingsService} from '../../settings/service/theme-setting.service';
import { TwoFactorEnum } from '../../settings/enum/settings-type.enum';
import { ReCaptchaV3Service } from 'ngx-captcha';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  @ViewChild('moduleSelectionDialog') dialog!: ElementRef<HTMLDialogElement>;

  constructor(
    private reCaptchaV3Service: ReCaptchaV3Service,
    private readonly formBuilder: FormBuilder,
    private readonly router: Router,
    private readonly authService: AuthService,
    private readonly themeService: ThemeSettingsService
  ) {
  }

  signInForm: FormGroup;
  showPassword: boolean = false;
  errorMessage: string = '';

  recaptchaToken: string = '';

  isVerificationForm:boolean=false
  verificationType:TwoFactorEnum|null=null;

  availableModules: { name: string; link: string; value: number,main:boolean }[] = [];

  ngOnInit() {
    this.signInForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]]
    });

    this.reCaptchaV3Service.execute(environment.captchaSiteKey, 'login', (token) => {
      this.recaptchaToken = token;
    }, { useGlobalDomain: false });
  }

  signIn() {
    if (this.signInForm.valid) {
      const {email, password} = this.signInForm.value;
      this.authService.checkUserAuthentication(email, password, this.recaptchaToken).subscribe({
        next:(res:any) => {
          if (res && typeof res === 'boolean' && res === true) {
            this.checkUserModules();
          } else if (res && 'isVerification' in res) {
            this.isVerificationForm=res?.isVerification;
            this.verificationType=res?.verificationType
            // 2FA yönlendirme ekranına git
          }
        }
      })
    }
  }

  private checkUserModules() {
    const user = localStorage.getItem('user');
    this.availableModules = user ? JSON.parse(user).modules?.map((m: any) => ({
      name: m.valueObject.name.value,
      link: m.valueObject.link.value,
      value: m.valueObject.id.value,
      main:m.valueObject.main.value==true?true:false
    })) : [];

    this.themeService.setUserThemeSettings();

    console.log(this.availableModules)

    if(this.availableModules.length === 0) {
      this.router.navigate(['/dashboard/operations']);
    } else if (this.availableModules.length === 1) {
      this.router.navigate([this.availableModules[0].link]);
    } else {
      this.dialog.nativeElement.showModal();
    }
  }

  selectModule(module: any) {
    this.authService.setActiveModule(module);
  }
  deleteModule() {
    this.authService.deleteActiveModule();
  }

  preventClose(event: Event): void {
    event.preventDefault();
  }

  sendOtpCode(data:{code:string}){
    const {email, password} = this.signInForm.value;
    const body={
      email:email,
      password:password,
      otpCode:data.code,
      verificationType:this.verificationType
   }
   this.authService.sendVerificationOtp(body).subscribe({
     next:(res:any) => {
       if(res){
         this.themeService.setUserThemeSettings()
         this.router.navigate(['/']);
       }
     }
   })
  }

  passwordPatternValidator() {
    return Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{4,12}$/);
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  onGoBack(){
    this.isVerificationForm=false;
    this.verificationType=null;
  }

  ngOnDestroy() {
    const badge = document.querySelector('.grecaptcha-badge');
    if (badge) {
      badge.remove();
    }
  }

}
